import Cookies from 'js-cookie';

/**
 * Centralizes all Cotton (Kotlin MW) feature flag logic.
 * - cottonAllowed: Cookie gate for Cotton traffic.
 */
const applePayAvailable = window.ApplePaySession;
const cottonFlagManager = {
  // Akamai cookie
  get cottonAllowed() {
    return Cookies.get('cotton_shield_allowed') === 'true';
  },

  // later we need to add the apple other condition for apple pay user
  get isCottonEnabled() {
    return this.cottonAllowed && applePayAvailable === undefined;
  },
  // Main switch for all oauth Ruby APIs
  get disableRubyApisPCI() {
    return true;
  },
};

export default cottonFlagManager;

export const isCottonSession = () => {
  const { isCottonEnabled } = cottonFlagManager;
  return isCottonEnabled;
};
